import ListUsers from "../views/ListUsers.vue";

export default [
  {
    path: "/users",
    component: ListUsers,
  },
];
